import Destacat from 'components/3catinfo/Destacat';
import styles from '../cosNoticia.module.scss';

const DestacatRelacionat = (props) => {
    const { id, src, alt, href, titol } = props;
    const destacat = {
        id: id,
        titol: titol,
        imatgeSrc: src,
        imatgeAlt: alt,
        href: href
    };

    return (
        <div className={styles.noticiaRelacionada} data-testid='cos-noticia-destacat-relacionat'>
            <Destacat
                estil='relacionada'
                key={`destacat-relacionat-${destacat.id}`}
                {...destacat}
                item={destacat}
                format='horitzontal'
            />
        </div>
    );
};

export default DestacatRelacionat;
